export default __webpack_public_path__ + "static/media/dsB.c98cf165.png";